import hotkeys from 'hotkeys-js';
import { isWindows } from '@/utils';
import {
  handleZoom, handleFitScreen, undo, redo,
} from '@/store/useAIToolsCanvasStore';

enum Scope {
  ALL_SCOPE = 'all',
  CANVAS_SCOPE = 'AI_TOOLS_CANVAS_SCOPE',
}

interface HotKeyItem {
  key: string;
  options?: { keydown?: boolean; keyup?: boolean; };
  handler: (event: KeyboardEvent) => void;
}

/**
 * 绑定热键
 */
export function bindHotKeys() {
  // 热键过滤，input等元素不触发热键
  hotkeys.filter = (event: KeyboardEvent) => {
    const target = (event.target || event.srcElement) as HTMLElement | null;
    const tagName = target?.tagName || '';
    const contenteditable = target?.getAttribute('contenteditable');
    return !(tagName === 'INPUT' || tagName === 'SELECT' || tagName === 'TEXTAREA' || !!contenteditable);
  };

  const hotKeyList: HotKeyItem[] = [
    // 放大
    {
      key: isWindows() ? 'ctrl+=, =, +' : 'command+=, =, +',
      handler: (event: KeyboardEvent) => {
        event.preventDefault();
        handleZoom(5);
      },
    },
    // 缩小
    {
      key: isWindows() ? 'ctrl+-, -' : 'command+-, -',
      handler: (event: KeyboardEvent) => {
        event.preventDefault();
        handleZoom(-5);
      },
    },
    // 撤销
    {
      key: isWindows() ? 'ctrl+z' : 'command+z',
      handler: (event: KeyboardEvent) => {
        event.preventDefault();
        undo();
      },
    },
    // 重做
    {
      key: isWindows() ? 'ctrl+shift+z' : 'command+shift+z',
      handler: (event: KeyboardEvent) => {
        event.preventDefault();
        redo();
      },
    },
    // 适应屏幕
    {
      key: 'shift+1',
      handler: (event: KeyboardEvent) => {
        event.preventDefault();
        handleFitScreen();
      },
    },
  ];

  hotKeyList.forEach((item) => {
    hotkeys(item.key, { ...item.options, scope: Scope.CANVAS_SCOPE }, item.handler);
  });

  hotkeys.setScope(Scope.CANVAS_SCOPE);
}

/**
 * 解绑热键
 */
export function unbindHotKeys() {
  hotkeys.setScope(Scope.ALL_SCOPE);
  hotkeys.unbind();
}
